// extracted by mini-css-extract-plugin
export var container = "_6a-0";
export var error = "_6a-9";
export var label = "_6a-5";
export var light = "_6a-6";
export var md = "_6a-3";
export var sm = "_6a-2";
export var thin = "_6a-8";
export var thinBold = "_6a-7";
export var vertical = "_6a-4";
export var xs = "_6a-1";